import ApiService from '../../../api/api';
import Vuex from 'vuex';
import Vue from 'vue';

Vue.use(Vuex);

const forEach = require('lodash/forEach');

export default {
    namespaced: true,
    state() {
        return {
            paginate: {},
            refreshAccess: false,
        }
    },
    getters: {
        memorials: (state) => {
            return state.paginate.hasOwnProperty('data')
                ? state.paginate.data
                : [];
        },
        paginate: (state) => {
            return state.paginate;
        },
        refreshAccess: (state) => {
            return state.refreshAccess;
        }
    },
    mutations: {
        setRefreshAccess(state, value) {
            state.refreshAccess = value;
        },
        setMemorialPaginate(state, value) {
            window.Vue.set(state, 'paginate', value);
        },
        updateMemorial(state, memorial) {
            let memorials = state.paginate.data ?? [];

            forEach(memorials, (item, key) => {
                if (item.id === memorial.id) {
                    window.Vue.set(state.paginate.data, key, memorial);
                }
            });
        },
    },
    actions: {
        index({state, commit, getters}, payload = {}) {
            return new Promise((resolve, reject) => {
                ApiService.get('/memorial', payload)
                    .then((response) => {
                        resolve(response);
                        commit('setMemorialPaginate', response.data);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        deleteMemorial({state, commit, getters}, memorial){
            return new Promise((resolve, reject) => {
                ApiService.delete('/memorial/' + memorial.id)
                    .then((response) => {
                        resolve(response);
                        commit('setRefreshAccess', true);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        incAmountViews({state, commit, getters}, id) {
            return new Promise((resolve, reject) => {
                ApiService.get('/memorial/inc-views/' + id)
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        reject(error);
                    });
            });
        },
        getMemorialsNearby({state, commit, getters}, payload) {
            return new Promise((resolve, reject) => {
                ApiService.get('/memorial/nearby', payload)
                    .then((response) => {
                        resolve(response)
                    })
                    .catch((error) => {
                        reject(error)
                    });
            })
        }
    }
};
